<div class="inmodal modal-lg" sharedUiModalFocusInput>
  <div class="modal-header">
    <h4 class="modal-title text-center full-width" id="modal-title">
      <span *ngIf="hasIcon">
        <shared-ui-icons-icon [iconName]="IconType.Mobile" [iconSize]="'84px'" class="modal-icon"></shared-ui-icons-icon>
        <br />
      </span>
      {{ title }}
    </h4>
    <button *ngIf="hasXButton" type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
  </div>
  <div *ngIf="hasBody" class="modal-body">
    <ng-content></ng-content>
  </div>
  <div class="modal-footer">
    <shared-ui-buttons-button *ngIf="canCancel" [text]="cancelButtonTitle" [type]="cancelButtonType" (action)="activeModal.dismiss()"></shared-ui-buttons-button>
    <shared-ui-buttons-button *ngIf="canConfirm && hasBrowseButton" [text]="'Browse'" [type]="ButtonType.DefaultOutline" (action)="browseOutput()"></shared-ui-buttons-button>
    <shared-ui-buttons-button
      *ngIf="hasRetryButton"
      [text]="retryButtonTitle"
      [type]="ButtonType.Primary"
      [disabled]="disableAllButtons"
      (action)="retryAction()"
    ></shared-ui-buttons-button>
    <shared-ui-buttons-button
      *ngIf="canConfirm"
      [disabled]="confirmButtonDisabled || disableAllButtons"
      [text]="confirmButtonTitle"
      [type]="ButtonType.Primary"
      (action)="confirmClose()"
    ></shared-ui-buttons-button>
    <shared-ui-buttons-button
      *ngIf="canConfirm && useSecondButton"
      [disabled]="confirmButtonDisabled || disableAllButtons"
      [text]="confirmSecondButtonTitle"
      [type]="ButtonType.Primary"
      (action)="confirmCloseSecondButton()"
    ></shared-ui-buttons-button>
    <shared-ui-buttons-button-copy-to-clipboard
      *ngIf="hasCopyButton && !canConfirm"
      [icon]="IconType.Copy"
      [type]="ButtonType.DefaultOutline"
      [textToCopy]="textToCopy"
    ></shared-ui-buttons-button-copy-to-clipboard>
  </div>
</div>
